//部署能力


import { useEffect, useRef, useState } from 'react';
import { RootObject, ImgList } from '../../type';
import VideoListItem from './VideoListItem';
import './style.less';



const DeploymentOfAbility = (props: RootObject["deploymentOfAbility"]) => {
  const [count, setCount] = useState<number>(0);
  const [leftArrowState, setLeftArrowState] = useState<boolean>(false);
  const [rightArrowState, setRightArrowState] = useState<boolean>(false);
  const ulRef = useRef<HTMLDivElement>(null);
  // 右箭头
  const rightArrow = () => {

    if (count === -2) {
      // setCount(0);
      // setArrowState(true);

    } else {
      setCount(count - 1);

    };
  };
  // 左箭头
  const leftArrow = () => {
    setLeftArrowState(true);
    setCount(count + 1);
    if (count === 0) {
      setCount(0);
     
    };
    if (count === 2) {
      setCount(0);
    };


  };

  useEffect(() => {
    if (ulRef.current) {

      ulRef.current.style.left = `${408 * count}px`;
    }
  }, [count]);
  useEffect(() => {
    if (count === -2) {
      setRightArrowState(true);
      setLeftArrowState(true);
    }else if(count === -1) {
      setLeftArrowState(true);
      setRightArrowState(false);
    }else if (count === 2){
      setLeftArrowState(false);
    }else if(count === 1){
      setRightArrowState(false);
    }else if(count === 0){
      setLeftArrowState(false);
      setRightArrowState(false);
    };
  }, [count]);
  
  return (
    <div className="deploymentOfAbility">
      <div className="deploymentOfAbility_title">
        {
          props.deploymentOfAbilityTitle ?? ""
        }
      </div>
      <div className="deploymentOfAbility_sub_title">
        {
          props.subTitle ?? ""
        }
      </div>
      {/* 轮播 */}
      <div className="deploymentOfAbility_shuffling">
        {/* 左箭头 */}
        <div
          className={leftArrowState === false ? "deploymentOfAbility_shuffling_left_arrow_disabled" : "deploymentOfAbility_shuffling_left_arrow"}
          onClick={() => leftArrowState === false ? undefined : leftArrow()}
        ></div>
        {/* 右箭头 */}
        <div
          className={rightArrowState === false ? "deploymentOfAbility_shuffling_right_arrow" : "deploymentOfAbility_shuffling_right_arrow_disabled"}
          onClick={() => rightArrowState === false ? rightArrow() : undefined}
        ></div>
        <div className="shuffling_wraaper">
          <div
            ref={ulRef}
            className="shuffling_ul"
          >
            {/* 视频 */}
            <div className="shuffling_ul_li">
              <VideoListItem
                backgroundVideo={"https://paddle-site-web-video.cdn.bcebos.com/EasyDeploy/%E7%9B%AE%E6%A0%87%E6%A3%80%E6%B5%8B.mp4"}
                link={"https://paddle-site-web-video.cdn.bcebos.com/EasyDeploy/%E7%9B%AE%E6%A0%87%E6%A3%80%E6%B5%8B.mp4"}
                title={"目标检测类算法"}
              />
            </div>
            <div className="shuffling_ul_li">
              <VideoListItem
                backgroundVideo={"https://paddle-site-web-video.cdn.bcebos.com/EasyDeploy/tinypose%E5%A7%BF%E6%80%81%E4%BC%B0%E8%AE%A1%20(online-video-cutter.com).mp4"}
                link={"https://paddle-site-web-video.cdn.bcebos.com/EasyDeploy/tinypose%E5%A7%BF%E6%80%81%E4%BC%B0%E8%AE%A1%20(online-video-cutter.com).mp4"}
                title={"姿态估计类算法"}
              />
            </div>
            <div className="shuffling_ul_li">
              <VideoListItem
                backgroundVideo={"https://paddle-site-web-video.cdn.bcebos.com/EasyDeploy/PP-OCRv3%E6%95%88%E6%9E%9C-0.mp4"}
                link={"https://paddle-site-web-video.cdn.bcebos.com/EasyDeploy/PP-OCRv3%E6%95%88%E6%9E%9C-0.mp4"}
                title={"OCR算法"}
              />
            </div>
            <div className="shuffling_ul_li">
              <VideoListItem
                backgroundVideo={"https://paddle-site-web-video.cdn.bcebos.com/EasyDeploy/%E8%BD%A8%E8%BF%B9%E9%A2%84%E6%B5%8B.mp4"}
                link={"https://paddle-site-web-video.cdn.bcebos.com/EasyDeploy/%E8%BD%A8%E8%BF%B9%E9%A2%84%E6%B5%8B.mp4"}
                title={"轨迹预测算法"}
              />
            </div>
            <div className="shuffling_ul_li">
              <VideoListItem
                backgroundVideo={"https://paddle-site-web-video.cdn.bcebos.com/EasyDeploy/Seg.mp4"}
                link={"https://paddle-site-web-video.cdn.bcebos.com/EasyDeploy/Seg.mp4"}
                title={"分割算法"}
              />
            </div>
          </div>
        </div>

      </div>
      {/* 二级标题 */}
      <div className="deploymentOfAbility_two_title">
        {
          props.twoTitle ?? ""
        }
      </div>
      {/* logo展示 */}
      <div className="logo_wrapper">
        {/* logo集 */}
        <div className="imgList">
          {
            props.imgList.map((value: ImgList, index: number) => {
              return (
                <div className="img" key={index} style={{ background: `url(${value.img})` }}></div>
              )
            })
          }
        </div>
        {/* 标题 */}
        <div className="logo_title">
          {
            props.threeTitle ?? ""
          }
        </div>
      </div>
    </div>
  )
}

export default DeploymentOfAbility;